
function splitDate (date)
{
    let separator

    if (date.split('/').length == 3)
    {
        separator =  '/'
    }
    else if (date.split('-').length == 3)
    {
        separator = '-'
    }

    return date.split(separator)
}

function dateToString (date, srcLang, dstLang, includeDayName)
{
    const isoDateSplit = splitDate(convertDateString(date, srcLang, 'iso'))
    const year = isoDateSplit[0]
    const month = Number.parseInt(isoDateSplit[1])
    let day = isoDateSplit[2]

    if (day[0] == '0') day = day.substr(1)

    if (dstLang == 'fr')
    {
        return `${day} ${months[dstLang][month]} ${year}`
    }
    else
    {
        console.error(`Language ${dstLang} is not supported for date parsing.`)
    }
}

function convertDateString (date, srcLang, dstLang, separator)
{
    if (!date) return null
    if (!srcLang) srcLang = 'iso'
    if (!dstLang) dstLang = 'iso'
    if (!separator) separator = '/'
    
    if (typeof date != 'string') date = date.toISOString()

    const splittedDate = splitDate(date)
    if (splittedDate.length < 3) return null
    let year, month, day

    if (srcLang == 'iso')
    {
        year = splittedDate[0].substr(0, 4)
        month = splittedDate[1].substr(0, 2)
        day = splittedDate[2].substr(0, 2)
    }
    else if (srcLang == 'en')
    {
        month = splittedDate[0].substr(0, 2)
        day = splittedDate[1].substr(0, 2)
        year = splittedDate[2].substr(0, 4)
    }
    else if (srcLang == 'fr')
    {
        day = splittedDate[0].substr(0, 2)
        month = splittedDate[1].substr(0, 2)
        year = splittedDate[2].substr(0, 4)
    }
    else console.error(`Cannot translate date ${date} from ${srcLang} to ${dstLang}`)

    switch (dstLang)
    {
        case 'iso': return `${year}${separator}${month}${separator}${day}`
        case 'en': return `${month}${separator}${day}${separator}${year}`
        case 'fr': return `${day}${separator}${month}${separator}${year}`

        default:
            console.error(`Cannot translate date ${date} from ${srcLang} to ${dstLang}`)
    }
}

function areSame (d1, d2)
{
    return new Date(d1).toString() == new Date(d2).toString()
}

function areSameDay (d1, d2)
{
    if ((!d1 || !d2) && (!d1 != !d2)) return false
    d1 = new Date(d1)
    d2 = new Date(d2)

    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
}

function stringDateNow ()
{
    let d = new Date()
    let mm = d.getMonth() + 1; // getMonth() is zero-based
    let dd = d.getDate();

    return [d.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('/');
}

function isValidDate (date, dateLang)
{
    if (!dateLang) dateLang = 'iso'

    const conv = convertDateString(date)
    if (!conv) return null

    const splitted = splitDate(conv)

    if (splitted[0].length != 4) return false

    switch (dateLang)
    {
        case 'iso':
            return splitted[1] > 0 && splitted[1] <= 12 && splitted[2] > 0 && splitted[2] <= 31

        default:
            throw new Error('Unknown date lang ' + dateLang)
    }
}

/**
 * 
 * @param {Date} date 
 */
function toIsoString (date, {includeTime = false} = {})
{
    var iso = date.toISOString()

    if (!includeTime)
    {
        // yyyy-mm-ddThh:mm:ssZ
        iso = iso.substr(0, iso.indexOf('T'))
    }

    return iso
}

/**
 * 
 * @param {Date} date 
 */
function add (date, {days = 0} = {})
{
    var final = new Date(date)
    
    final.setDate(final.getDate() + days)

    return final
}

/**
 * 
 * @param {Date?} date 
 * @returns {Date}
 */
function getUTCNow (date)
{
    if (!date) date = new Date(); 
    var now_utc =  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

    return new Date(now_utc);
}

const months =
{
    fr:
    {
        1: 'janvier',
        2: 'février',
        3: 'mars',
        4: 'avril',
        5: 'mai',
        6: 'juin',
        7: 'juillet',
        8: 'aôut',
        9: 'septembre',
        10: 'octobre',
        11: 'novembre',
        12: 'décembre',
    }
}

const days =
{
    fr:
    {
        0: 'lundi',
        1: 'mardi',
        2: 'mercredi',
        3: 'jeudi',
        4: 'vendredi',
        5: 'samedi',
        6: 'dimanche'
    }
}

export default { splitDate, dateToString, areSame, areSameDay, stringDateNow, convertDateString, isValidDate, toIsoString, add, days, getUTCNow }


// WEBPACK FOOTER //
// ./src/utils/dateUtils.js